interface IException {
	ar: string;
	en: string;
	showModel?: boolean;
}
interface IExceptions {
	[key: string]: IException;
}

export const MICROSOFT_PAGE = 'https://www.office.com/setup365';
export const MICROSOFT_ADMIN_PAGE = 'https://admin.microsoft.com/Adminportal/Home';
export const MS_PRODUCT_QUERY_PARAM = 'digitalproducts';

export const GET_ACCOUNT_BI = 'getCurrentAccount';
export const MAKASIB_BI = 'getMakasibAccount';

const errorCodesWithSameDescription = [
	'omannet_IPAY0100074',
	'omannet_IPAY0100075',
	'omannet_IPAY0100076',
	'omannet_IPAY0100077',
	'omannet_IPAY0100078',
	'omannet_IPAY0100079',
	'omannet_IPAY0100225',
	'omannet_IPAY0100226',
	'omannet_IPAY0100227',
	'omannet_IPAY0100228',
	'omannet_IPAY0100229',
];
const commonExceptionDescription = {
	ar: 'تم رفض المعاملة بسبب خطأ في رمز انتهاء بطاقة البنك.',
	en: 'Transaction has been declined due to an invalid card expiry details.',
	showModel: true,
};
const sameErrorException = errorCodesWithSameDescription.reduce(
	(acc, curr) => ((acc[curr] = commonExceptionDescription), acc),
	{} as Record<string, IException>
);

export const PAYMENT_EXCEPTIONS: IExceptions = {
	...sameErrorException,
	cybersource_202: {
		ar: 'تم رفض العملية بسبب انتهاء صلاحية البطاقة.',
		en: 'Transaction has been declined due to an expired card.',
		showModel: true,
	},
	cybersource_204: {
		ar: 'تم رفض العملية لعدم توفر رصيد كافٍ في الحساب.',
		en: 'Transaction has been denied due to insufficient funds in the account',
		showModel: false,
	},
	cybersource_205: {
		ar: 'تم رفض العملية لأن البطاقة مفقودة أو مسروقة.',
		en: 'Transaction has been denied due to stolen or lost card',
		showModel: false,
	},
	cybersource_210: {
		ar: 'تم رفض المعاملة بسبب تجاوز البطاقة الحد الائتماني المسموح به.',
		en: `Transaction has been declined due to the card's reaching its credit limit`,
		showModel: false,
	},
	cybersource_211: {
		ar: 'تم رفض المعاملة بسبب خطأ في رمز التحقق (CVV).',
		en: `Transaction has been declined due to an invalid CVN (card verification number).`,
		showModel: true,
	},
	cybersource_231: {
		ar:
			'تم رفض المعاملة من قبل البنك بسبب خطأ في رقم الحساب البنكي. يرجى التحقق مع البنك الخاص بك او استخدام بطاقة اخرى.',
		en: `The transaction has been declined by the Bank due to Invalid account number. Kindly check with your bank or use another card.`,
		showModel: false,
	},
	cybersource_251: {
		ar: 'تم رفض المعاملة، أو تم تجاوز معدل استخدام بطاقة الخصم بدون رقم سري أو الحد الأقصى للمبلغ.',
		en: `Transaction has been declined, the pinless debit card's use frequency or maximum amount has been exceeded.`,
		showModel: false,
	},
	cybersource_481: {
		ar: 'تم رفض الطلب من قبل مدير القرار.',
		en: `The order is being rejected by the Decision Manager`,
		showModel: false,
	},
	omannet_IPAY0100224: {
		ar: 'تم رفض المعاملة بسبب رقم CVV غير صالح (رقم التحقق من البطاقة).',
		en: `Transaction has been declined due to an invalid CVV (card verification number).`,
		showModel: true,
	},
	omannet_IPAY0100118: {
		ar: 'تم رفض المعاملة بسبب خطأ في رقم البطاقة.',
		en: `Transaction has been declined due to an invalid card number.`,
		showModel: true,
	},
	omannet_IPAY0100121: {
		ar: 'تم رفض المعاملة بسبب خطا في اسم حامل بطاقة البنك.',
		en: `Transaction has been declined due to an invalid card holder name.`,
		showModel: true,
	},
	omannet_IPAY0100081: {
		ar: 'تم رفض المعاملة بسبب خطا في اسم حامل بطاقة البنك.',
		en: `Transaction has been declined due to an invalid card holder name.`,
		showModel: true,
	},
	omannet_IPAY0100222: {
		ar: 'تم رفض المعاملة بسبب خطا في اسم حامل بطاقة البنك.',
		en: `Transaction has been declined due to an invalid card holder name.`,
		showModel: true,
	},
	omannet_IPAY0100200: {
		ar: 'تم رفض المعاملة بسبب حظر قائمة سلة المهملات، يرجى تجربة بطاقة خصم محلية أخرى',
		en: `Transaction declined due to block bin list, please try another local debit card`,
		showModel: false,
	},
	omannet_IPAY0100207: {
		ar: 'يرجى استخدام بطاقة خصم صادرة من عمان.',
		en: `Please use Oman Issued debit card`,
		showModel: false,
	},
	omannet_IPAY0100049: {
		ar: 'لا يمكن معالجة المعاملة بسبب خطأ تقني. يرجى المحاولة لاحقا.',
		en: `Transaction can not be processed due to a technical error, please try later.`,
		showModel: false,
	},
	omannet_IPAY0100092: {
		ar: 'تم رفض المعاملة بسبب عدم ادخال رمز التحقق (OTP)',
		en: `Transaction declined due to empty OTP number`,
		showModel: false,
	},
	omannet_IPAY0100093: {
		ar: 'تم رفض المعاملة بسبب خطأ في رمز التحقق (OTP)',
		en: `Transaction declined due to invalid OTP number`,
		showModel: false,
	},
	omannet_IPAY0200085: {
		ar: ' رقم البطاقة غير مسجل لخدمة OTP.',
		en: `Card Number not registered for OTP`,
		showModel: false,
	},
	omannet_IPAY0200075: {
		ar: 'تم تجاوز الحد المسموح به لمحاولات ادخال رمز التحقق (OTP)',
		en: `OTP Tries Exceeded`,
		showModel: false,
	},
	default: {
		ar: 'تم رفض المعاملة من قبل البنك. يرجى التحقق مع البنك الخاص بك أو استخدام بطاقة أخرى',
		en: 'The transaction has been declined by the Bank. Kindly check with your bank or use another card.',
		showModel: false,
	},
};
